import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";

const Pagination = ({
  itemsPerPage,
  totalItems,
  onPageChange,
  currentPage,
  setRowsPerPage,
  itemsLength,
  setPage,
  rowsPrPageList = [],
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    onPageChange(page);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      handlePageChange(nextPage);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      handlePageChange(prevPage);
    }
  };

  const renderDots = () => {
    const dots = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        dots.push(
          <li key={i} className="page-item">
            <button
              onClick={() => handlePageChange(i)}
              className={`${
                i === currentPage ? "active page-link" : "page-link"
              }`}
            >
              {i}
            </button>
          </li>
        );
      }
    } else {
      const startPage = Math.max(1, currentPage - 1);
      const endPage = Math.min(totalPages, currentPage + 1);

      if (startPage > 1) {
        dots.push(
          <li key="start">
            <button onClick={() => handlePageChange(1)} className="page-link">
              1
            </button>
          </li>
        );
        if (startPage > 2) {
          dots.push(
            <li key="ellipsis-start">
              <span>...</span>
            </li>
          );
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        dots.push(
          <li key={i}>
            <button
              onClick={() => handlePageChange(i)}
              className={`${
                i === currentPage ? "active page-link" : "page-link"
              }`}
            >
              {i}
            </button>
          </li>
        );
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          dots.push(
            <li key="ellipsis-end">
              <span>...</span>
            </li>
          );
        }
        dots.push(
          <li key="end">
            <button
              onClick={() => handlePageChange(totalPages)}
              className="page-link"
            >
              {totalPages}
            </button>
          </li>
        );
      }
    }

    return dots;
  };

  const option =
    rowsPrPageList && rowsPrPageList.length > 0
      ? rowsPrPageList
      : [9, 18, 36, 72];

  return (
    <div className="theme-pagination mt-5">
      <div className="pagination">
        <select
          value={itemsPerPage}
          onChange={(e) => {
            setRowsPerPage(Number(e.target.value));
            setPage(1);
          }}
          className="border-0"
        >
          {option.map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>

        <ul className="pagination-counter-arrows">
          <li className="pagination-right-left page-item">
            <button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className="page-link"
            >
              <FaAngleLeft />
            </button>
          </li>

          {renderDots()}

          <li className="pagination-right-left page-item">
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="page-link"
            >
              <FaAngleRight />
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Pagination;
